import * as React from 'react';
import { FC, useState } from 'react';
import moment from 'moment/moment';
import { LotteryProps, Day, Prize, WheelState } from './types';
import Prizes from './Prizes';
import Wheel from './Wheel';
import Days from './Days';
import RoundEndNotification from './RoundEndNotification';
import { LocalesContext } from './locales';

const dayAvailableTicketsNumber = (day: Day) => day.tickets.reduce((sum, ticket) => sum + (ticket.prize ? 0 : 1), 0);

const availableTicketsNumber = (days: Day[]) => days.reduce((sum, day) => sum + dayAvailableTicketsNumber(day), 0);

const Lottery: FC<LotteryProps> = (props) => {
  const [{ anonymous, days, prizes, locales }, setData] = useState(props);

  const [page, setPage] = useState<{
    availableTickets: number;
    days: Day[];
    prizes: Prize[];
  }>({
    availableTickets: availableTicketsNumber(days),
    days,
    prizes,
  });

  const lotteryDates = { start: props.start_date, end: props.end_date };

  const pageStateChange = (onStateChange: WheelState) => {
    if (onStateChange === 'stopped') {
      setPage({
        availableTickets: availableTicketsNumber(days),
        days,
        prizes,
      });
    }
  };

  const today = moment.utc();
  const endDate = moment.utc(props.end_date);

  return (
    <LocalesContext.Provider value={locales}>
      <div className="lottery_widget l-w">
        {endDate < today ? <RoundEndNotification endDay={props.end_date_time} lang={props.lang} /> : null}
        <div className="l-w_columns">
          <Prizes prizes={page.prizes} />
          <Wheel
            availableTicketsNumber={page.availableTickets}
            onWin={setData}
            prizes={prizes}
            onStateChange={pageStateChange}
            lotteryDates={lotteryDates}
            lang={props.lang}
          />
        </div>
        <Days showPastDays={!anonymous} days={page.days} />
      </div>
    </LocalesContext.Provider>
  );
};

const WrappedLottery: FC<LotteryProps> = (props) => <Lottery {...props} />;

export default WrappedLottery;
